import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "fw-medium text-black-emphasis mb-20" }
const _hoisted_4 = { class: "version-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "d-block fs-md-15 text-black fw-medium" }
const _hoisted_7 = { class: "d-block text-paragraph text-uppercase small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.consent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t('feature.consent.version_history')), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versions, (version) => {
              return (_openBlock(), _createElementBlock("div", {
                key: version.revision_number,
                class: _normalizeClass(["d-flex align-items-center justify-content-between py-2 border-bottom border-light-subtle", [{ 'opacity-50': version.published_at === undefined, 'cursor-pointer': version.published_at !== undefined}]]),
                onClick: ($event: any) => (_ctx.show(version as ConsentVersion))
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(version.revision_number), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_7, _toDisplayString(version.published_at !== undefined ? _ctx.formatDate(version.published_at) : _ctx.$t('feature.consent.draft')), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}